import * as z from 'zod';

import { itemIdValidator, nullableCoercedNumberInput, nullableNumberInput } from './helpers';

export const ggaFreeSpinsSchema = z
  .object({
    gameId: itemIdValidator('Game').min(1, { message: 'Game is required.' }),
    freespinAmount: nullableNumberInput(),
    betAmount: nullableCoercedNumberInput(),
  })
  .superRefine((data, context) => {
    if (
      data.freespinAmount == null ||
      !Number.isInteger(data.freespinAmount) ||
      data.freespinAmount < 1 ||
      data.freespinAmount > 10_000
    ) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['freespinAmount'],
        message: 'Must be a whole number between 1 and 10,000.',
      });
    }

    if (data.betAmount == null || data.betAmount <= 0) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['betAmount'],
        message: 'Bet amount must be greater than 0.',
      });
    } else if (Number(data.betAmount.toFixed(2)) !== data.betAmount) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['betAmount'],
        message: 'Bet amount must have no more than 2 decimal places.',
      });
    }
  });

export type GgaFreeSpinsFormData = z.infer<typeof ggaFreeSpinsSchema>;
